// Categorías do marketplace — mapean a valores do backend.
// Leyro só admite apeiros agrícolas SEN MOTOR (decisión 2026-04-24).
// As categorías motorizadas (TRATAMENTOS, ANIMAL, HORTA, TRANSPORTE) NON
// se mostran no buscador para evitar confusión, aínda que se manteñen no
// enum do schema por compatibilidade con datos históricos.
export const CATEGORIES = [
  { id: "all",          label: "Todos",                          icon: "LayoutGrid",  type: "all" },
  { id: "LABOREO",      label: "Apeiros de laboreo",             icon: "Sprout",      type: "machine" },
  { id: "RECOLECCION",  label: "Apeiros de recolección",         icon: "Wheat",       type: "machine" },
  { id: "SIEMBRA",      label: "Apeiros de sementeira",          icon: "Sprout",      type: "machine" },
  { id: "AUXILIAR",     label: "Apeiros auxiliares",             icon: "Forklift",    type: "machine" },
  { id: "PRADO",        label: "Terras de cultivo",              icon: "Fence",       type: "terra" },
  { id: "LABRADIO",     label: "Terreos",                        icon: "MapPin",      type: "terra" },
  // Filtro especial: non é categoría real senón un atallo a fincas oficiais
  // do Banco de Terras (Xunta). Layout intercepta o clic e navega con
  // ?type=finca&source=BANCO_TERRAS.
  { id: "BANCO_TERRAS", label: "Organismos Públicos",            icon: "TreePine",    type: "terra", isSourceFilter: true },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map(c => [c.id, c]));
